import { render, staticRenderFns } from "./DayProjectList.vue?vue&type=template&id=2380f10c&scoped=true&"
import script from "./DayProjectList.vue?vue&type=script&lang=js&"
export * from "./DayProjectList.vue?vue&type=script&lang=js&"
import style0 from "./DayProjectList.vue?vue&type=style&index=0&id=2380f10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2380f10c",
  null
  
)

export default component.exports